module.exports = __webpack_public_path__ + "img/vi_VN.2c44f2d.jpg";